import {Grid, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {T} from 'react-polyglot-hooks';
import {ContactUsContent} from '../../components/ContactUs/ContactUs';
import {getMe} from '../../graphql/auth';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4)
    }
}));

const Contact = () => {
    const classes = useStyles();
    const meData = getMe();
    const name = meData && meData.data && meData.data.me && (meData.data.me.first_name + ' ' + meData.data.me.last_name);
    const email = meData && meData.data && meData.data.me && meData.data.me.email;

    return (
        <div className={classes.root}>
            <Grid container spacing={4}>
                <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Typography variant="h1">
                        <T phrase="Contact us"/>
                    </Typography>
                </Grid>

                <Grid item lg={12} md={12} xl={12} xs={12}>
                    <ContactUsContent
                        heading="Contact Us"
                        message="Please get in touch and let us know how we can help you."
                        adminMessage={'Contact Page logged in user: ' + email}
                        email={email} name={name}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default Contact;
